import styled, { css } from "styled-components";

export const ContentWrapper = styled.div`
  padding: 20px 15px;
  max-width: 1000px;
  margin: 0 auto;
`;

export const PageTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 8px;
  color: #142c1f;
`;

export const PageSubtitle = styled.p`
  color: #818d88;
  margin-bottom: 20px;
`;

export const CardsContainer = styled.div`
  @media (min-width: 992px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaeaea;
  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h2`
  font-size: 18px;
  color: #142c1f;
  margin: 0;
`;

export const HelpLink = styled.a`
  font-size: 14px;
  color: #2ecf96;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const CardDescription = styled.p`
  color: #44554c;
  margin-bottom: 16px;
  font-weight: normal;
`;

export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
`;

export const OptionItem = styled.div`
  position: relative;
  border-radius: 8px;
  padding: 8px 0;
  width: 70px;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 5px #00000014;
  border-radius: 8px;

  ${({ selected }) =>
    selected &&
    css`
      border: 1px solid #2ecf96;
      background-color: #f3fffd;
    `}

  &:hover {
    border-color: #2ecf96;
  }
  @media screen and (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const OptionLabel = styled.div`
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 3px;
  color: ${(props) => (props.selected ? "#2ecf96" : "#818D88")};
  text-align: center;
  font-weight: 500;
`;

export const OptionValue = styled.div`
  font-size: 5px;
`;

export const SelectionIndicator = styled.div`
  position: absolute;
  top: 1px;
  right: 5px;
  width: 14px;
  height: 14px;
  border-radius: 3px;

  background-color: #2ecf96;

  &::after {
    content: "";
    position: absolute;
    width: 7px;
    height: 4px;
    border-left: 2px solid white;
    border-bottom: 2px solid white;
    transform: rotate(-45deg);
    top: 2px;
    left: 3px;
  }
`;
export const EmptySquare = styled.div`
  position: absolute;
  top: 2px;
  right: 5px;
  width: 12px;
  height: 12px;
  /* UI Properties */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 2px #1018280d;
  border: 1px solid #d0d5dd;
  border-radius: 3px;
  opacity: 1;
  @media screen and (max-width: 768px) {
    top: 1px;
    right: 3px;
    width: 10px;
    height: 10px;
  }
`;
export const OptionIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  @media screen and (max-width: 768px) {
    width: 25px;
    height: 25px;
  }

  // Style the SVG shape itself
  svg {
    // Set fill color based on selection state
    fill: ${(props) => (props.selected ? "#2ECF96" : "#D9D9D9")};
    transition: fill 0.2s ease-in-out;
  }
`;
export const RangeDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 20px;
  padding-top: 10px;

  span {
    font-size: 10px;
    font-weight: 600;
  }
`;
